export const UPDATE_IS_TARGET_OUT_OF_POCKET = 'UPDATE_IS_TARGET_OUT_OF_POCKET';
